export default {
  aiAssistant: {
    greeting: "您好！我是智能助手小图。",
  },
  messages: {
    sessionExpired: "登录过期请重新登录",
  },
};
